import { lazyForPaint } from 'react-loosely-lazy';
import type { Route } from 'react-resource-router';
import { withRouter } from 'react-resource-router';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

const AsyncHelpCenterEditDetailsPage = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: "async-help-center-edit-details-page" */ '@atlassian/admin-layout').then(
            ({ HelpCenterEditDetails }) => HelpCenterEditDetails
        )
    ),
});

const AsyncHelpCenterManageProjectsPage = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: "async-help-center-manage-projects-page" */ '@atlassian/admin-layout').then(
            ({ HelpCenterManageProjects }) => HelpCenterManageProjects
        )
    ),
});

export const helpcenterEditRoute: Route = {
    name: 'edit-details',
    path: '/edit-details',
    exact: true,
    component: withRouter(AsyncHelpCenterEditDetailsPage),
};

export const helpcenterManageProjectsRoute: Route = {
    name: 'manage-projects',
    path: '/manage-projects',
    exact: true,
    component: withRouter(AsyncHelpCenterManageProjectsPage),
};
